import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import { api } from '../lib/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.getCakes({ includeUnavailable: 'true' }).then(({ cakes }) => {
      setStats({
        total: cakes.length,
        available: cakes.filter(c => c.isAvailable).length,
        soldOut: cakes.filter(c => !c.isAvailable).length,
        featured: cakes.filter(c => c.featured).length,
      });
    });
  }, []);

  return (
    <AdminLayout title="Dashboard">
      <div className="admin-stats">
        <StatCard label="Total Cakes" value={stats?.total} loading={!stats} />
        <StatCard label="Available" value={stats?.available} loading={!stats} />
        <StatCard label="Sold Out" value={stats?.soldOut} loading={!stats} />
        <StatCard label="Featured" value={stats?.featured} loading={!stats} />
      </div>

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        <Link to="/admin/cakes/new" className="admin-btn admin-btn-primary">+ Add a New Cake</Link>
        <Link to="/admin/cakes" className="admin-btn admin-btn-outline">Manage All Cakes</Link>
        <Link to="/admin/settings" className="admin-btn admin-btn-outline">Pricing & Delivery Settings</Link>
      </div>
    </AdminLayout>
  );
}

function StatCard({ label, value, loading }) {
  if (loading) {
    return (
      <div className="admin-skel-stat-card">
        <span className="admin-skel" style={{ width: 80, height: 10, marginBottom: 12 }} />
        <span className="admin-skel" style={{ width: 40, height: 28 }} />
      </div>
    );
  }

  return (
    <div className="admin-stat-card">
      <p className="admin-stat-label">{label}</p>
      <p className="admin-stat-value">{value === undefined ? '—' : value}</p>
    </div>
  );
}